<!--
  BulkActionBar.vue -- Phase 4.4 bulk action bar.

  Card: 2026-06-13 design bundle implementation -- https://trello.com/c/hYlwyKYT
  Pebble: Phase 4.4 bulk action bar.

  Appears below the products list when at least one product is
  selected. Three actions:

    * Apply decoration set -- emits ``apply-set`` (the modal itself is
      Phase 4.6 -- this bar fires the emit, the parent shows a TODO
      stub until 4.6 ships).
    * Duplicate -- emits ``duplicate``.
    * Set visibility -- emits ``set-visibility``.

  Per P4-Q9 the bar operates on ALL selected products regardless of
  visibility or draft status; selection-filtering happens upstream in
  the parent / Pinia store. The bar is purely presentational here.
-->
<template>
    <div
        v-if="selectedCount > 0"
        class="bulk-action-bar"
        data-testid="bulk-action-bar"
        role="toolbar"
        aria-label="Bulk actions for selected products"
    >
        <span class="bulk-action-bar__count" data-testid="bulk-action-count">
            {{ selectedCount }} selected
        </span>
        <div class="bulk-action-bar__spacer"></div>
        <button
            type="button"
            class="bulk-action-bar__button"
            data-testid="bulk-action-apply-set"
            @click="$emit('apply-set')"
        >
            Apply decoration set
        </button>
        <button
            type="button"
            class="bulk-action-bar__button"
            data-testid="bulk-action-duplicate"
            @click="$emit('duplicate')"
        >
            Duplicate
        </button>
        <button
            type="button"
            class="bulk-action-bar__button"
            data-testid="bulk-action-set-visibility"
            @click="$emit('set-visibility')"
        >
            Set visibility
        </button>
    </div>
</template>

<script>
export default {
    name: 'BulkActionBar',
    props: {
        selectedCount: {
            type: Number,
            required: true,
            default: 0,
        },
    },
    emits: ['apply-set', 'duplicate', 'set-visibility'],
}
</script>

<style scoped>
.bulk-action-bar {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 16px;
    background: #f1f5f9;
    border: 1px solid #cbd5e1;
    border-radius: 6px;
    margin: 12px 0;
    position: sticky;
    bottom: 0;
    z-index: 5;
}
.bulk-action-bar__count {
    font-weight: 600;
    color: #334155;
    font-size: 13px;
}
.bulk-action-bar__spacer {
    flex: 1 1 auto;
}
.bulk-action-bar__button {
    appearance: none;
    background: #fff;
    border: 1px solid #cbd5e1;
    border-radius: 4px;
    padding: 6px 12px;
    font-size: 13px;
    color: #1e293b;
    cursor: pointer;
}
.bulk-action-bar__button:hover {
    background: #e2e8f0;
}
</style>
